<template>
  <nav-bar title="信息确认" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <van-form @submit="handleSubmit">
      <Field :disabled="true" name="userTypeName" :defaultValue="oldForm.userTypeName" label="客户类型"  />
      <Field :disabled="true" name="companyName" :defaultValue="oldForm.companyName" label="客户名"  />
      <Field :disabled="true" name="creditNo" :defaultValue="oldForm.creditNo" label="客户代码"  />
      <Field :disabled="true" name="userName" :defaultValue="oldForm.userName" label="联系人"  />
      <Field :disabled="true" name="phoneNum" :defaultValue="oldForm.phoneNum" label="联系电话"  />
      <Field :disabled="true" name="streetName" :defaultValue="oldForm.streetName" label="街道"  />
      <Field :disabled="true" name="address" :defaultValue="oldForm.address" label="地址"  />
      <Field
        label="位置"
        :disabled="true"
        :defaultValue="`${oldForm.latitude}, ${oldForm.longitude}`"
      />
      <!-- <van-field label="是否反馈">
        <template #input>
          <van-radio-group v-model="oldForm.backFlag " direction="horizontal">
            <van-radio name="0">是</van-radio>
            <van-radio name="1">否</van-radio>
          </van-radio-group>
        </template>
      </van-field> -->
    </van-form>
    <div class="btn-container">
        <van-button
          block
          type="primary"
          :loading="loading"
          loading-text="请稍后..."
          :disabled="loading"
          native-type="button"
          @click="onSubmit"
        >
          确认
        </van-button>
      </div>

  </Content>
</template>

<script>
import { getCustomerDetail, updateAccordFlagById } from '@/api/customer'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useSubmit } from '@/hooks/useSubmit'

export default {
  name: 'InformationConfirmation',
  props: ['id'],
  setup (props) {
    const oldForm = reactive({})
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(getCustomerDetail, (data) => {
      for (const key in data) {
        oldForm[key] = data[key]
      }
    }, props.id)
    getDataLoading()
    const router = useRouter()
    const { onSubmit, loading } = useSubmit(updateAccordFlagById, props.id, () => {
      router.back()
    })
    return { getDataLoading, showLoading, isLoading, oldForm, onSubmit, loading }
  }
}
</script>

<style lang="scss" scoped>
.btn-container {
  margin: 16px;
}
</style>
